import { createElement } from "react";
import { safeHash, equals, createObj } from "../../../../fable_modules/fable-library.3.7.9/Util.js";
import { contains, ofArray, empty, singleton } from "../../../../fable_modules/fable-library.3.7.9/List.js";
import { FSharpMap__ContainsKey } from "../../../../fable_modules/fable-library.3.7.9/Map.js";
import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "../../../../fable_modules/Fable.Promise.3.1.3/Promise.fs.js";
import { promise } from "../../../../fable_modules/Fable.Promise.3.1.3/PromiseImpl.fs.js";
import { fetch$ } from "../../../../fable_modules/Fable.Fetch.2.4.0/Fetch.fs.js";
import { replace, match } from "../../../../fable_modules/fable-library.3.7.9/RegExp.js";
import { LoadedCorpus_Msg, LoadedCorpus_ShowingResults_Concordance_Msg } from "../../../Update.js";
import { Helpers_combineClasses } from "../../../../fable_modules/Feliz.Bulma.2.18.0/ElementBuilders.fs.js";
import { Interop_reactApi } from "../../../../fable_modules/Feliz.1.64.0/Interop.fs.js";
import { Record } from "../../../../fable_modules/fable-library.3.7.9/Types.js";
import { option_type, record_type, array_type, class_type, string_type } from "../../../../fable_modules/fable-library.3.7.9/Reflection.js";
import { singleton as singleton_1, append, delay, toList } from "../../../../fable_modules/fable-library.3.7.9/Seq.js";
import { Corpus__get_SharedInfo } from "../../../Model/Model.js";
import { ExternalTool } from "../../../../Shared/Shared.js";
import { join } from "../../../../fable_modules/fable-library.3.7.9/String.js";

export function TranslationButton(translationButtonInputProps) {
    let elems, props, properties_1;
    const dispatch = translationButtonInputProps.dispatch;
    const googleTransKey = translationButtonInputProps.googleTransKey;
    const translations = translationButtonInputProps.translations;
    const fullText = translationButtonInputProps.fullText;
    const rowIndex = translationButtonInputProps.rowIndex;
    const pageNumber = translationButtonInputProps.pageNumber;
    const translationKey = `${pageNumber}_${rowIndex}`;
    return createElement("div", createObj(ofArray([["style", {
        display: "inline-block",
        marginLeft: 7,
        marginRight: 1,
        marginBottom: 2,
    }], (elems = [(props = ofArray([["className", "is-small"], (properties_1 = singleton(["fontSize", 10 + "px"]), ["style", createObj(properties_1)]), ["disabled", FSharpMap__ContainsKey(translations, translationKey)], ["onClick", (_arg1) => {
        const searchText = encodeURI(fullText);
        const url = `https://www.googleapis.com/language/translate/v2?q=${searchText}&key=${googleTransKey}&target=${"en"}`;
        const pr = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (fetch$(url, empty()).then((_arg2) => (_arg2.text().then((_arg3) => {
            const m = match(/translatedText":\s*"(.+?)",/g, _arg3);
            if (m != null) {
                dispatch(new LoadedCorpus_ShowingResults_Concordance_Msg(19, translationKey, m[1] || ""));
                return Promise.resolve();
            }
            else {
                return Promise.resolve();
            }
        }))))));
        void pr;
    }], ["title", "Translate with Google Translate"], ["children", "Trans"]]), createElement("button", createObj(Helpers_combineClasses("button", props))))], ["children", Interop_reactApi.Children.toArray(Array.from(elems))])])));
}

export function TranslationButtonSaami(pageNumber, rowIndex, fullText, translations, googleTransKey, dispatch) {
    let elems, props, properties_1;
    const translationKey = `${pageNumber}_${rowIndex}`;
    return createElement("div", createObj(ofArray([["style", {
        display: "inline-block",
        marginLeft: 7,
        marginRight: 1,
        marginBottom: 2,
    }], (elems = [(props = ofArray([["className", "is-small"], (properties_1 = singleton(["fontSize", 10 + "px"]), ["style", createObj(properties_1)]), ["disabled", FSharpMap__ContainsKey(translations, translationKey)], ["onClick", (_arg1) => {
        const searchText = encodeURI(fullText);
        const url = `https://gtweb.uit.no/apy/translate?langpair=sme|nob&q=${searchText}`;
        const pr = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (fetch$(url, empty()).then((_arg2) => (_arg2.text().then((_arg3) => {
            const m = match(/translatedText":\s*"(.+?)"/g, _arg3);
            if (m != null) {
                dispatch(new LoadedCorpus_ShowingResults_Concordance_Msg(19, translationKey, m[1] || ""));
                return Promise.resolve();
            }
            else {
                return Promise.resolve();
            }
        }))))));
        void pr;
    }], ["title", "Translate with Giellatekno Apertium"], ["children", "Trans"]]), createElement("button", createObj(Helpers_combineClasses("button", props))))], ["children", Interop_reactApi.Children.toArray(Array.from(elems))])])));
}

export class ResultLineFields extends Record {
    constructor(SId, PreMatch, SearchWord, PostMatch) {
        super();
        this.SId = SId;
        this.PreMatch = PreMatch;
        this.SearchWord = SearchWord;
        this.PostMatch = PostMatch;
    }
}

export function ResultLineFields$reflection() {
    return record_type("View.LoadedCorpus.ResultViews.Cwb.Common.ResultLineFields", [], ResultLineFields, () => [["SId", string_type], ["PreMatch", array_type(class_type("Fable.React.ReactElement"))], ["SearchWord", array_type(class_type("Fable.React.ReactElement"))], ["PostMatch", array_type(class_type("Fable.React.ReactElement"))]]);
}

export class ResultInfo extends Record {
    constructor(Word, MaybeOrig) {
        super();
        this.Word = Word;
        this.MaybeOrig = MaybeOrig;
    }
}

export function ResultInfo$reflection() {
    return record_type("View.LoadedCorpus.ResultViews.Cwb.Common.ResultInfo", [], ResultInfo, () => [["Word", ResultLineFields$reflection()], ["MaybeOrig", option_type(ResultLineFields$reflection())]]);
}

export function idColumn(corpus, model, sId, messageId, maybeFullText, rowIndex, loadedCorpusDispatch, dispatch) {
    let children_5, children, elems, children_3;
    const textId = replace(sId, "\\..+", "");
    const children_7 = ofArray([(children_5 = ofArray([(children = singleton(createElement("a", createObj(ofArray([["href", ""], ["onClick", (e) => {
        e.preventDefault();
        e.stopPropagation();
        loadedCorpusDispatch(new LoadedCorpus_Msg(25, corpus, textId));
    }], (elems = [createElement("span", {
        children: [sId],
    })], ["children", Interop_reactApi.Children.toArray(Array.from(elems))])])))), createElement("div", {
        children: Interop_reactApi.Children.toArray(Array.from(children)),
    })), (children_3 = toList(delay(() => {
        let matchValue, fullText, key_3;
        return append((matchValue = [Corpus__get_SharedInfo(corpus).GoogleTranslateApiKey, maybeFullText], (matchValue[0] != null) ? ((matchValue[1] != null) ? ((fullText = matchValue[1], (key_3 = matchValue[0], contains(new ExternalTool(0), Corpus__get_SharedInfo(corpus).ExternalTools, {
            Equals: equals,
            GetHashCode: safeHash,
        }) ? singleton_1(createElement(TranslationButton, {
            pageNumber: model.ResultPageNo,
            rowIndex: rowIndex,
            fullText: fullText,
            translations: model.Translations,
            googleTransKey: key_3,
            dispatch: dispatch,
        })) : (contains(new ExternalTool(1), Corpus__get_SharedInfo(corpus).ExternalTools, {
            Equals: equals,
            GetHashCode: safeHash,
        }) ? singleton_1(TranslationButtonSaami(model.ResultPageNo, rowIndex, fullText, model.Translations, key_3, dispatch)) : singleton_1(null))))) : singleton_1(null)) : singleton_1(null)), delay(() => {
            let elems_3, props_5, properties_2, elems_2, elms;
            return Corpus__get_SharedInfo(corpus).IsTreebank ? singleton_1(createElement("div", createObj(ofArray([["style", {
                display: "inline-block",
                marginLeft: 1,
                marginRight: 1,
                marginBottom: 2,
            }], (elems_3 = [(props_5 = ofArray([["className", "is-small"], (properties_2 = singleton(["fontSize", 10 + "px"]), ["style", createObj(properties_2)]), ["title", "Show syntactic tree"], ["onClick", (_arg1) => {
                dispatch(new LoadedCorpus_ShowingResults_Concordance_Msg(20, `${model.ResultPageNo}_${rowIndex}`));
            }], (elems_2 = [(elms = singleton(createElement("i", {
                className: join(" ", ["fa fa-sitemap"]),
            })), createElement("span", {
                className: "icon",
                children: Interop_reactApi.Children.toArray(Array.from(elms)),
            }))], ["children", Interop_reactApi.Children.toArray(Array.from(elems_2))])]), createElement("button", createObj(Helpers_combineClasses("button", props_5))))], ["children", Interop_reactApi.Children.toArray(Array.from(elems_3))])])))) : singleton_1(null);
        }));
    })), createElement("div", {
        children: Interop_reactApi.Children.toArray(Array.from(children_3)),
    }))]), createElement("div", {
        children: Interop_reactApi.Children.toArray(Array.from(children_5)),
    })), corpus["Model.Corpus.ResultLinksZ731E88D3"](model.ResultPageNo, rowIndex, textId, messageId, Corpus__get_SharedInfo(corpus))]);
    return createElement("div", {
        children: Interop_reactApi.Children.toArray(Array.from(children_7)),
    });
}

export function textColumns(resultLineFields) {
    if (!(resultLineFields.SearchWord.length === 0)) {
        return ofArray([createElement("td", {
            key: 0,
            className: "left-context",
            children: Interop_reactApi.Children.toArray(Array.from(resultLineFields.PreMatch)),
        }), createElement("td", {
            key: 1,
            className: "match",
            children: Interop_reactApi.Children.toArray(Array.from(resultLineFields.SearchWord)),
        }), createElement("td", {
            key: 2,
            className: "right-context",
            children: Interop_reactApi.Children.toArray(Array.from(resultLineFields.PostMatch)),
        })]);
    }
    else {
        return singleton(createElement("td", {
            colSpan: 3,
            children: Interop_reactApi.Children.toArray(Array.from(resultLineFields.PreMatch)),
        }));
    }
}

export function separatorRow(rowIndex) {
    let elems;
    return createElement("tr", createObj(ofArray([["key", `sep${rowIndex}`], ["style", {
        backgroundColor: "#f1f1f1",
    }], (elems = [createElement("td", {
        colSpan: 4,
        style: {
            padding: 2,
        },
    })], ["children", Interop_reactApi.Children.toArray(Array.from(elems))])])));
}

export function SyntaxTree(syntaxTreeInputProps) {
    return null;
}

